import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";
import UrlHelper from "@Scripts/Infrastructure/UrlHelper";

@Component({ name: "CookieToast" })
export default class CookieToast extends Vue {
    public localizer: any = Localizer;
    public customizeCookieValues: string[] = ["tech"];

    @Prop() readonly mode: string;

    get isCookieToastVisible() {
        return this.$store.getters["cookieToastStore/isCookieToastVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isCookieToastVisible") async onCookieToastVisibilityUpdate(newValue: boolean) {
        this.$store.commit("cookieToastStore/setCookieToastVisible", newValue);
    }

    public async created() {
        let allowedCookieTypes = UrlHelper.getUrlParamValue("allowedcookietypes");

        if (!CookieHelper.isCookiePolicy() && this.mode !== "Embed" && !allowedCookieTypes) {
            this.$store.commit("cookieToastStore/setCookieToastVisible", true);
        }

        if (allowedCookieTypes) {
            let values = allowedCookieTypes.split(",");

            let isValid: boolean = true;

            for (let value of values) {
                if (value !== "tech" && value !== "stat" && value != "profile") {
                    isValid = false;
                }
            }

            if (isValid) {
                if (!values.includes("tech")) {
                    values.push("tech")
                }

                let duration = values.includes("tech") && values.length === 1 ? 14 : 730;

                CookieHelper.setCookie("ckpl", values.join("|"), duration);
            }
        }
    }

    public setCookieToastAll() {
        CookieHelper.setCookiePolicyAll();
        this.$store.commit("cookieToastStore/setCookieToastVisible", false);
        window.location.reload();
    }

    public setCookieToastRecommended() {
        CookieHelper.setCookie("ckpl", "tech|stat", 730);
        this.$store.commit("cookieToastStore/setCookieToastVisible", false);
        window.location.reload();
    }

    public setRejectAll() {
        CookieHelper.setCookie("ckpl", "tech", 14);
        this.$store.commit("cookieToastStore/setCookieToastVisible", false);
        window.location.reload();
    }
};